module.exports = __webpack_public_path__ + "img/4-8150.17c4c1ef.png";